// Vue resolves an absent optional boolean prop to false, not undefined, so a caller that forgets
// byType silently forces false instead of falling back to the page's own grouping.
export const resolveByType = (explicitByType: boolean | undefined, currentGroupingByType: boolean): boolean =>
  explicitByType ?? currentGroupingByType;
